<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-textarea v-model:value="formData[widget.name]" :disabled="widget.options.disabled"
            :placeholder="widget.options.placeholder" :allowClear="widget.options.allowClear"
            :maxlength="widget.options.maxLength" :autoSize="widget.options.autoSize" :showCount="widget.options.showCount"
            @change="handleOnChange" @pressEnter="handleOnPressEnter">
        </a-textarea>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnChange,
    handleOnPressEnter,
} = useEvent(widget.value, itemref, formData.value);
</script>